<template>
  <div class="simple-countdown" :style="countdownStyle">
    <div v-if="countdownSettings.showDays" class="countdown-block">
      <div class="countdown-digit">{{ displayDays }}</div>
      <div class="countdown-label">Days</div>
    </div>
    <div v-if="countdownSettings.showHours" class="countdown-block">
      <div class="countdown-digit">{{ displayHours }}</div>
      <div class="countdown-label">Hours</div>
    </div>
    <div v-if="countdownSettings.showMinutes" class="countdown-block">
      <div class="countdown-digit">{{ displayMinutes }}</div>
      <div class="countdown-label">Minutes</div>
    </div>
    <div v-if="countdownSettings.showSeconds" class="countdown-block">
      <div class="countdown-digit">{{ displaySeconds }}</div>
      <div class="countdown-label">Seconds</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleCountdown',
  props: ['endDate', 'countdownSettings'],
  data() {
    return {
      displayDays: '00',
      displayHours: '00',
      displayMinutes: '00',
      displaySeconds: '00',
      timer: null
    };
  },
  computed: {
    countdownStyle() {
      return {
        color: this.countdownSettings.textColour || '#000000',
        '--background-color': this.countdownSettings.backgroundColour || 'transparent'
      };
    },
    _seconds() {
      return 1000;
    },
    _minutes() {
      return this._seconds * 60;
    },
    _hours() {
      return this._minutes * 60;
    },
    _days() {
      return this._hours * 24;
    }
  },
  mounted() {
    this.showRemaining();
    this.timer = setInterval(this.showRemaining, 1000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  methods: {
    formatNum(num) {
      return num < 10 ? '0' + num : num;
    },
    showRemaining() {
      const timer = new Date(this.endDate).getTime() - new Date().getTime();

      if (timer < 0) {
        clearInterval(this.timer);
        this.displayDays = '00';
        this.displayHours = '00';
        this.displayMinutes = '00';
        this.displaySeconds = '00';
        return;
      }

      const days = Math.floor(timer / this._days);
      const hours = Math.floor((timer % this._days) / this._hours);
      const minutes = Math.floor((timer % this._hours) / this._minutes);
      const seconds = Math.floor((timer % this._minutes) / this._seconds);

      this.displayDays = this.formatNum(days);
      this.displayHours = this.formatNum(hours);
      this.displayMinutes = this.formatNum(minutes);
      this.displaySeconds = this.formatNum(seconds);
    }
  }
}
</script>

<style scoped>
.simple-countdown {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: var(--background-color);
  padding: 20px;
  border-radius: 10px;
  font-family: 'Arial', sans-serif;
}

.countdown-block {
  padding: 0 20px;
}

.countdown-digit {
  font-size: 4rem;
  font-weight: bold;
}

.countdown-label {
  font-size: 1rem;
  text-transform: uppercase;
  margin-top: 5px;
}
</style>